var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        attrs: {
          model: _vm.selected,
          items: _vm.collection,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          clearable: _vm.clearable,
          showAdd: _vm.showAdd,
          disableAdd: _vm.disableAdd,
          disabled: _vm.disabled,
          dense: _vm.dense,
          autoComplete: _vm.autoComplete,
          multiple: _vm.multiple,
          selectAll: _vm.selectAll,
          "item-text": _vm.itemText,
          outlined: _vm.outlined,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          onShowForm: function ($event) {
            _vm.showForm = true
          },
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
        },
      }),
      _vm.modelObject && _vm.modelObject.course
        ? _c("sys-register-group", {
            attrs: {
              model: { course: _vm.modelObject.course },
              show: _vm.showForm,
            },
            on: {
              onCompleted: _vm.newItem,
              "update:show": function ($event) {
                _vm.showForm = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }